import { render, staticRenderFns } from "./icon-pdf.vue?vue&type=template&id=11f3657c&"
import script from "./icon-pdf.vue?vue&type=script&lang=js&"
export * from "./icon-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports